import { ComponentType } from 'react';
import { Inventory } from './Inventory';
import { OptionsMenu } from './OptionsMenu';
import { EscapeMenu } from './EscapeMenu';
import { MapScreen } from './MapScreen';
import { ChestScreen } from './ChestScreen';
import { LoadoutScreen } from './LoadoutScreen';
import { EquipmentScreen } from './EquipmentScreen';
import { TalentTreeScreen } from './TalentTreeScreen';
import { CommodeScreen } from './CommodeScreen';
import { BestiaryScreen } from './BestiaryScreen';
import { ShopScreen } from './ShopScreen';
import { SpellEquipScreen } from './SpellEquipScreen';
import { DevItemsScreen } from './DevItemsScreen';
import { MultiplayerScreen } from './MultiplayerScreen';

/**
 * Each entry is a self-contained component responsible for its own input and
 * close logic (`closeInterface()`). Unknown ids fall back to
 * UnknownInterfaceScreen so a bad id never freezes the game.
 */
export const INTERFACE_REGISTRY: Record<string, ComponentType> = {
  'escape-menu': EscapeMenu,
  inventory: Inventory,
  options: OptionsMenu,
  map: MapScreen,
  chest: ChestScreen,
  loadout: LoadoutScreen,
  equipment: EquipmentScreen,
  talents: TalentTreeScreen,
  commode: CommodeScreen,
  bestiary: BestiaryScreen,
  shop: ShopScreen,
  // B8 — the Wandering Merchant location calls `openInterface({id:'wandering-merchant'})`
  // directly. ShopScreen reads the current shop via `gameStore.currentShopId` OR
  // falls back to the current interfaceId (see ShopScreen), avoiding the need to
  // route through an NPC.
  'wandering-merchant': ShopScreen,
  'spell-equip': SpellEquipScreen,
  'dev-items': DevItemsScreen,
  multiplayer: MultiplayerScreen,
};

export type InterfaceId = keyof typeof INTERFACE_REGISTRY;

export function isKnownInterface(id: string): boolean {
  return id in INTERFACE_REGISTRY;
}
